import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0207a330"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12.00503",
  height: "23.010099",
  viewBox: "0 0 12.00503 23.010099",
  version: "1.1"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M 0.50505012,22.50505 11.50505,11.50505 0.50505012,0.50505012" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = () => _ctx.clickHandler()),
    class: _normalizeClass(["frisbuy-button-arrow", [`--${_ctx.direction}`, `--${_ctx.mode}`]])
  }, _hoisted_2, 2))
}